import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../messages/general-export-messages';
import style from '../export-records-modal.module.less';

export const AddFieldsErrorMessage = () => {
  return (
    <div className={style['form-error-message']}>
      <FormattedMessage {...messages.missingColumnSelection} />
    </div>
  );
};
